import { render, staticRenderFns } from "./Portability.vue?vue&type=template&id=007894ba&scoped=true"
import script from "./Portability.vue?vue&type=script&lang=js"
export * from "./Portability.vue?vue&type=script&lang=js"
import style0 from "./Portability.vue?vue&type=style&index=0&id=007894ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007894ba",
  null
  
)

export default component.exports